export const ACCEPTED_IMAGE_TYPES = ['image/png', 'image/jpeg', 'image/webp'];
export const MAX_UPLOAD_BYTES = 5 * 1024 * 1024;

export interface ItemModalDraft {
  id: string;
  name: string;
  code: string;
  category: string;
  status: 'available' | 'unavailable';
  imageUrl: string | null;
}

export interface ItemModalErrors {
  id?: string;
  name?: string;
  code?: string;
  category?: string;
  status?: string;
  image?: string;
  submit?: string;
}

export function validateItemDraft(draft: ItemModalDraft, uploadFile: File | null): ItemModalErrors {
  const errors: ItemModalErrors = {};

  if (!draft.name.trim()) {
    errors.name = 'Name is required.';
  }

  if (!draft.code.trim()) {
    errors.code = 'Code is required.';
  }

  if (uploadFile) {
    if (!ACCEPTED_IMAGE_TYPES.includes(uploadFile.type)) {
      errors.image = 'Please upload a PNG, JPG, or WEBP image.';
    } else if (uploadFile.size > MAX_UPLOAD_BYTES) {
      errors.image = 'Image must be 5 MB or smaller.';
    }
  }

  return errors;
}
